import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

export const useCreateRoleMutation = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("BETTY_ADMIN_USER_TOKEN");

  return useMutation({
    mutationFn: (payload: any) =>
      axiosInstance
        .post(`admins/roles`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      message.success(data?.message);
      navigate("/admin-management/explore-roles");
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
